import React, { FC, useState, MouseEvent } from "react";
import classes from "./style/OrgDescription.module.css";
import { UI_ITOTooltip } from "../../../UI_ITO/indexUI";

interface OrgDescriptionProps {
  organization: string;
  inn: string;
  number: number;
  date: string;
  purchase_number: string;
  sum: string;
  status: string;
  link: string;
  fz: string;
  bg_name: string;
  header: boolean;
  name: string;
}
const OrgDescription: FC<OrgDescriptionProps> = (props) => {
  const { header, bg_name, fz, link, name, inn, purchase_number } = props;
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseOver = (event: MouseEvent) => {
    const targetElement = event.target as HTMLDivElement;
    if (
      targetElement.offsetWidth < targetElement.scrollWidth &&
      targetElement
    ) {
      setTooltipVisible(true);
    }
  };

  const handleMouseOut = () => {
    setTooltipVisible(false);
  };

  return (
    <div className={classes.infoOrganization}>
      {header && (
        <div className={classes.infoHeader}>
          <UI_ITOTooltip title={name} isOpen={isTooltipVisible}>
            <div
              className={classes.orgHeader}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              {name}
            </div>
          </UI_ITOTooltip>
          <div className={classes.orgInn}>ИНН {inn}</div>
        </div>
      )}
      <div className={classes.appBg}>
        <div>БГ {bg_name}</div>
      </div>
      <div className={classes.appNumbers}>
        <div className={classes.appNumbersFirst}>
          Закупка {fz === "commerce" ? "Коммерческая" : `по ${fz}-ФЗ`}
        </div>
        <a
          target="_blank"
          href={link}
          className={classes.appNumbersSecond}
          rel="noreferrer"
          onClick={(event) => event.stopPropagation()}
        >
          {purchase_number}
        </a>
      </div>
      {/* <div className={classes.appNumbers}>
        <div className={classes.appNumbersFirst}>Сумма</div>
        <div className={classes.appNumbersSecond}>{PraiceSpace(sum)}</div>
      </div> */}
    </div>
  );
};

export default OrgDescription;
